<div class="overflow-hidden rounded-2xl bg-gradient-to-r from-[#1D3549] to-[#24597E] p-[1px] shadow-sm">
  <div class="space-y-4 rounded-2xl bg-white px-5 py-6 text-center">
    <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#1CAAFC]/10 text-[#1CAAFC]">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.2V11a6 6 0 1 0-12 0v3.2a2 2 0 0 1-.6 1.4L4 17h5m6 0v1a3 3 0 1 1-6 0v-1m6 0H9"/>
      </svg>
    </div>

    <div class="space-y-2">
      <div class="text-lg font-bold text-slate-900">ລະບົບຂ່າວສານກຳລັງປັບປຸງ</div>
      <div class="text-sm leading-6 text-slate-600">
        ຂະນະນີ້ລະບົບຂ່າວສານ ແລະ ປະກາດບໍ່ພ້ອມໃຊ້ງານຊົ່ວຄາວ.
        ກະລຸນາລອງໃໝ່ອີກພາຍຫຼັງ.
      </div>
    </div>

    <div class="rounded-xl bg-slate-50 px-4 py-3 text-left text-sm leading-6 text-slate-600">
      <div class="font-semibold text-slate-800">ສະຖານະບໍລິການ:</div>
      <div>ທີມງານກຳລັງກວດສອບ ຫຼື ປັບປຸງລະບົບ ເພື່ອໃຫ້ບໍລິການກັບມາໃຊ້ໄດ້ຕາມປົກກະຕິ.</div>
    </div>

    <div class="inline-flex items-center rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-700">
      ບໍ່ພ້ອມໃຊ້ງານຊົ່ວຄາວ
    </div>
  </div>
</div>
